module.exports = __webpack_public_path__ + "static/media/39-9.7fe5c735.mp3";